import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFAB from './components/WhatsAppFAB';
import ScrollToTop from './components/ScrollToTop';
import AnnouncementModal from './components/AnnouncementModal';
import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import PortfolioPage from './pages/PortfolioPage';

// Routes that render their own header and should hide the public Navbar.
const HIDE_NAVBAR_ROUTES = ['/portfolio'];

function AppShell() {
  const { pathname } = useLocation();
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const hideNavbar = HIDE_NAVBAR_ROUTES.includes(normalizedPath);

  return (
    <>
      {!hideNavbar && <Navbar />}

      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
        </Routes>
      </main>

      <Footer />
      <WhatsAppFAB />
      <ScrollToTop />
      <AnnouncementModal />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen bg-white">
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
